// Error class for errors that should not cause a toaster

export class SilentError extends Error {}
